import { productByHandleQuery, productByIdQuery } from '../lib/shopify.queries';
import { shopRequest } from '../lib/shopify.client';
import { useState, useEffect } from 'react';

type ProductInput = {
  handle?: string;
  id?: string;
};

export const useShopifyProduct = ({ handle, id }: ProductInput) => {
  const [product, setProduct] = useState<any>(null);



  useEffect(() => {
    const fetchProduct = async () => {
      if (!handle && !id) {
        console.error('Either handle or id must be provided');
        return;
      }

      if (handle) {
        const response = await shopRequest<{ productByHandle: any }>(
          productByHandleQuery,
          {
            handle,
          }
        );

        setProduct(response.productByHandle);
      } else {
        const response = await shopRequest<{ product: any }>(productByIdQuery, {
          id,
        });
        setProduct(response.product);
      }
    };

    fetchProduct();
  }, [handle, id]);

  return product;
};
